module.exports = __webpack_public_path__ + "img/rs_blueL-logo.873ae37.png";